function initOpenCloseCard() {
  try {
    function removeDot(elemClass) {
      let mainActiveClass = ''
      let mainArray = elemClass.split('')
      let mainClass = mainArray.map((item, index) =>
        item == '.' ? mainArray.splice(index, 0) : (mainActiveClass += item),
      )
      return mainActiveClass
    }

    function animation(animated, el) {
      switch (animated) {
        case 'toggle':
          $(el).toggle(300)
          break
        case 'slideDown':
          $(el).slideDown(300)
          break
        case 'slideUp':
          $(el).slideUp(300)
          break
        case 'slideToggle':
          $(el).slideToggle(300)
          break
        case 'fadeToggle':
          $(el).fadeToggle(300)
          break
      }
    }

    function toggleShow(
      mainElem,
      elements,
      btn,
      animated = 'slideToggle',
      addMainActive = false,
    ) {
      window.addEventListener('click', e => {
        if (e.target.closest(btn)) {
          const parent = e.target.closest(mainElem)
          const nodes = elements.map(selector =>
            parent.querySelector(`.${selector}`),
          )

          addMainActive &&
            parent.classList.toggle(`${removeDot(mainElem)}--active`)

          for (const node of nodes) {
            animation(animated, node)
          }
        } else {
          if (
            btn === '.Card-product__have-icon-js' ||
            btn === '.Badges__interaction-last-img'
          ) {
            const nodes = elements.map(selector =>
              document.querySelector(`.${selector}[style="display: block;"]`),
            )

            for (const node of nodes) {
              animation('slideToggle', node)
            }
          }
        }
      })
      // document.addEventListener("mousedown", (event) => {
      // 	if (event.target.closest(mainElem) && event.target.closest(btn)) {
      // 		let pathMain = event.target.closest(mainElem);
      // 		let elemsToggleShow = [];

      // 		if (addMainActive) {
      // 			pathMain.classList.toggle(`${removeDot(mainElem)}--active`);
      // 		}
      // 		elements.forEach((itemElems) => {
      // 			elemsToggleShow.push(pathMain.querySelector(`.${itemElems}`));
      // 		});
      // 		elemsToggleShow.forEach((itemElem) => {
      // 			switch (animated) {
      // 				case "toggle":
      // 					$(itemElem).toggle(300);
      // 					break;
      // 				case "slideDown":
      // 					$(itemElem).slideDown(300);
      // 					break;
      // 				case "slideUp":
      // 					$(itemElem).slideUp(300);
      // 					break;
      // 				case "slideToggle":
      // 					$(itemElem).slideToggle(300);
      // 					break;
      // 				case "fadeToggle":
      // 					$(itemElem).fadeToggle(300);
      // 					break;
      // 			}
      // 		});
      // 	} else if (btn === '.Card-product__have-icon-js' &&	!event.target.closest(`.${elements.pop()}`)) {
      // 		console.log(12)
      // 	}
      // });
    }
    toggleShow(
      '.Card-product',
      ['Card-product__block-specification-js'],
      '.Card-product__btn-specifications-js',
      'ssss',
      true,
    )

    toggleShow(
      '.Card-product',
      ['Card-product__block-have-info-js'],
      '.Card-product__have-icon-js',
      'slideToggle',
    )

    toggleShow(
      '.Card-product',
      ['Card-product__block-termo-js'],
      '.Badges__interaction-last-img',
      'slideToggle',
    )

    toggleShow(
      '.Card-product-aflat',
      ['Card-product-aflat__block-have-info-js'],
      '.Card-product-aflat__have-icon-js',
      'slideToggle',
    )
    toggleShow(
      '.Card-buy__wrapper-item-products',
      ['item-Card-buy__detailed'],
      '.item-Card-buy__amount-btn',
      'slideToggle',
    )
    toggleShow('.raffle', ['raffle__extra'], '.raffle__btn', 'slideToggle')
    toggleShow(
      '.ordering-page__block-delivery',
      ['ordering-page__delivery-map'],
      '.Button--js',
      'slideToggle',
      true,
    )
    toggleShow(
      '.information-account',
      ['information-account__content'],
      '.information-account__title',
      'slideToggle',
      true,
    )
    toggleShow(
      '.Description',
      ['Description__content-list--extra'],
      '.Description__btns',
      'slideToggle',
      true,
    )
    toggleShow(
      '.Description-list',
      ['Description__content-list--extra-two'],
      '.Description__btns-desc',
      'slideToggle',
      true,
    )
    toggleShow(
      '.Offers',
      ['Offers__extra'],
      '.Offers__btns',
      'slideToggle',
      true,
    )
	toggleShow(
		'.filter-products__info',
		['filter-products__info-list'],
		'.filter-products__info-header-name',
		'slideToggle',
		true,
	  )
    function showMore() {
      let main = document.querySelector('.best-quality-guarantee__wrapper')
      let cards = main.querySelectorAll('.Card-product')
      let btn = main.querySelector('.best-quality-guarantee__button > a')
      let num = 6

      cards.forEach((el, index) => {
        if (index >= num) {
          el.style.display = 'none'
        }
      })
      btn.onclick = () => {
        let cardsArray = []
        cards.forEach((el, index) => {
          if (el.hasAttribute('style')) {
            cardsArray.push(el)
          }
        })
        if (cardsArray.length < num) {
          btn.setAttribute('style', 'display:none;')
        }
        cardsArray.forEach((el, index) => {
          if (index < num) {
            el.removeAttribute('style')
          }
        })
      }
    }
    showMore()
  } catch (e) {}
}
